import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AgentsService } from '../services/agents.service';

/**
 * resolve route by injecting data returned by {@link AgentsService}
 * @returns {object} list of agents
 */
export const agentsResolver: ResolveFn<unknown> = () => inject( AgentsService ).getAgents();
